import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			//首页
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			//首页
			path: '/Projects',
			name: 'Projects',
			component: (resolve) => require(['@/views/Projects.vue'], resolve),
		},
		{
			//首页
			path: '/Team',
			name: 'Team',
			component: (resolve) => require(['@/views/Team.vue'], resolve),
		},
		{
			//首页
			path: '/ContactUs',
			name: 'ContactUs',
			component: (resolve) => require(['@/views/ContactUs.vue'], resolve),
		},
		// {
		// 	//首页
		// 	path: '/us',
		// 	name: 'us',
		// 	component: (resolve) => require(['@/views/us.vue'], resolve),
		// },
		//cooperate
	],
})
